<template>
  <footer class="footer">
    <div class="container">
      <!-- Columna 1: Info de sedes -->
      <div class="footer-section">
        <div class="info">
          <img
            src="../assets/icons/ubicacion.png"
            alt="Logo"
            class="icon green-filter"
          />
          <div>
            <p>Sede Neiva</p>
            <p>Calle 31 SUR N° 15 81 Zona Industrial</p>
          </div>
        </div>
        <div class="info">
          <img
            src="../assets/icons/telefono-inteligente.png"
            alt="Teléfono"
            class="icon green-filter"
          />
          <div>
            <p>(+57) 3102125747</p>
            <p>Administración CFIM</p>
          </div>
        </div>
        <div class="info">
          <img
            src="../assets/icons/carta.png"
            alt="Correo"
            class="icon green-filter"
          />
          <div>
            <p>gerencia@cfimsas.net</p>
            <p>administracion@cfimsas.net</p>
          </div>
        </div>
        <div class="info">
          <img
            src="../assets/icons/ubicacion.png"
            alt="Logo"
            class="icon green-filter"
          />
          <div>
            <p>Sede Sabaneta</p>
            <p>Carrera 44 calle 57 SUR 62 Bodega 132</p>
          </div>
        </div>
        <div class="info">
          <img
            src="../assets/icons/telefono-inteligente.png"
            alt="Teléfono"
            class="icon green-filter"
          />
          <div>
            <p>(+57) 3183599225</p>
          </div>
        </div>
        <div class="info">
          <img
            src="../assets/icons/carta.png"
            alt="Correo"
            class="icon green-filter"
          />
          <div>
            <p>admonmedellin@cfimsas.net</p>
          </div>
        </div>
      </div>

      <!-- Columna 2: Info sede Sabaneta -->
      <div class="footer-section">
        <div class="logo-container">
          <img
            src="../assets/CFIM-ISOTIPO.png"
            alt="Logo CFIM"
            class="logo-cfim"
          />
        </div>
      </div>

      <!-- Columna 3: Mapa -->
      <div class="footer-section map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d837.6824451071436!2d-75.27940571810976!3d2.89917470230739!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8e3b73bd88c79bb3%3A0xaceb5aa02fedf0cd!2sCFIM%20SAS!5e0!3m2!1ses!2sco!4v1740237015989!5m2!1ses!2sco"
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>

    <div class="footer-bottom">
      <p>Copyright © 2025 IT MANAGEMENT ZOMAC SAS</p>
    </div>
  </footer>
</template>

<style scoped>
.footer {
  background-color: #f0f0f0;
  color: black;
  padding: 40px 20px;
  border-radius: 2rem 2rem 0 0;
  font-family: Arial, sans-serif;
}

.container {
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  flex-wrap: wrap;
  gap: 20px;
}

.footer-section {
  width: 32.2%;
  box-sizing: border-box;
}

.info {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.icon {
  height: 35px;
  margin-right: 10px;
}

.green-filter {
  filter: invert(42%) sepia(91%) saturate(333%) hue-rotate(90deg)
    brightness(95%) contrast(85%);
}

.logo-container {
  text-align: center;
  margin-bottom: 20px;
}

.logo-cfim {
  max-width: 100%;
  height: auto;
}

p {
  margin: 2px 0;
  text-align: left;
  font-size: 14px;
}

.map-container iframe {
  width: 150%;
  height: 300px;
  border: 0;
  border-radius: 8px;
}

.footer-bottom {
  width: 100%;
  display: flex;
  justify-content: center; /* Centra el contenido horizontalmente */
  align-items: center; /* Centra el contenido verticalmente si es necesario */
  text-align: center;
  font-size: 14px;
  border-top: 1px solid #ccc;
  padding-top: 10px;
  color: #555;
  margin-top: 20px; /* Opcional: separa visualmente del contenido superior */
}

@media (max-width: 1024px) {
  .footer-section {
    width: 48%;
  }
}

@media (max-width: 768px) {
  .container {
    flex-direction: column;
    align-items: center;
  }
  .footer-section {
    width: 100%;
    text-align: center;
  }
  .info {
    justify-content: center;
  }
  p {
    font-size: 16px;
  }
  .icon {
    height: 28px;
    margin-right: 8px;
  }
}
</style>
